var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-full" },
    [
      _vm.loaded
        ? _c(
            "div",
            { staticClass: "h-full" },
            [
              _c(
                "div",
                { staticClass: "claim-content h-full flex flex-column" },
                [
                  _c("LayoutTopNav", {
                    attrs: { "claim-by-id": _vm.claim },
                    on: { update: _vm.getClaim }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "h-full flex" }, [
                    _c("div", { staticClass: "left-layout col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "container" },
                        [
                          _c("div", { staticClass: "container" }, [
                            _c("div", { staticClass: "job-info mt-4" }, [
                              _c("div", { staticClass: "row pb-3" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-6" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: "/jobs/edit/" + _vm.claim.job_id,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "job_ref_id" },
                                          [_vm._v(_vm._s(_vm.claim.job.ref_id))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "job_title" }, [
                                      _vm._v(_vm._s(_vm.claim.job.source.name))
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c("span", { staticClass: "job_title" }, [
                                    _vm._v("Total price")
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "job_content" }, [
                                    _vm._v(
                                      "$" +
                                        _vm._s(
                                          _vm.claim.job.total_price.slice(0, -3)
                                        )
                                    )
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: " pb-2 flex" }, [
                              _c("span", { staticClass: "price-per-row" }, [
                                _c("span", { staticClass: "job_title" }, [
                                  _vm._v("Per hour")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "job_content" }, [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        Math.round(_vm.claim.job.price_per_hour)
                                      )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "flex align-items-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "job_content movers-row mr-20 trucks-movers"
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "mod-icon mod-icon-movers"
                                      }),
                                      _vm._v(_vm._s(_vm.claim.job.movers))
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "job_content trucks-movers"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon mod-icon-trucks"
                                      }),
                                      _vm._v(_vm._s(_vm.claim.job.trucks))
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row pb-2" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("span", { staticClass: "job_title" }, [
                                  _vm._v("Moving company")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "job_content" }, [
                                  _vm._v(_vm._s(_vm.claim.job.company.name))
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row pb-2" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("span", { staticClass: "job_title" }, [
                                  _vm._v("Carrier")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _vm.claim.job.carrier
                                  ? _c("span", { staticClass: "job_content" }, [
                                      _vm._v(_vm._s(_vm.claim.job.carrier.name))
                                    ])
                                  : _c("span", { staticClass: "job_content" }, [
                                      _vm._v("-")
                                    ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row pb-2" }, [
                              _c("div", { staticClass: "col-md-6" }, [
                                _c("span", { staticClass: "job_title" }, [
                                  _vm._v("Move date")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "job_content" }, [
                                  _vm._v(_vm._s(_vm.claim.job.move_date))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6" }, [
                                _c("span", { staticClass: "job_title" }, [
                                  _vm._v("Move Duration")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _vm.claim.job.total_hours
                                  ? _c("span", { staticClass: "job_content" }, [
                                      _vm._v(
                                        _vm._s(_vm.claim.job.total_hours) + "h"
                                      )
                                    ])
                                  : _c("span", { staticClass: "job_content" }, [
                                      _vm._v("-")
                                    ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.showMore === true
                              ? _c("div", { staticClass: "row pb-2" }, [
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _c("span", { staticClass: "job_title" }, [
                                      _vm._v("Lead created by")
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _vm.claim.job &&
                                    _vm.claim.job.lead_created_by
                                      ? _c(
                                          "span",
                                          { staticClass: "job_content" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.claim.job.lead_created_by
                                                  .username
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "job_content" },
                                          [_vm._v("-")]
                                        )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6" }, [
                                    _c("span", { staticClass: "job_title" }, [
                                      _vm._v("Job assigned to")
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _vm.claim.job.cluster_user !== null
                                      ? _c(
                                          "span",
                                          { staticClass: "job_content" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.claim.job.cluster_user
                                                  .username
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "job_content" },
                                          [_vm._v("-")]
                                        )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 pt-2" }, [
                                    _c("span", { staticClass: "job_title" }, [
                                      _vm._v("Min hours")
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "job_content" }, [
                                      _vm._v(
                                        _vm._s(_vm.claim.job.minimum_hours)
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row pb-2" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _vm.showMore === false
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "show-more",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.showMore = true
                                          }
                                        }
                                      },
                                      [_vm._v("Show more")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "show-more",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.showMore = false
                                          }
                                        }
                                      },
                                      [_vm._v("Show less")]
                                    )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("CustomerInfo", {
                            attrs: { job: _vm.claim.job },
                            on: {
                              openM: function($event) {
                                _vm.showCustomerModal = true
                              },
                              update: _vm.getClaim
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right-layout flex" }, [
                      _c("div", { staticClass: "list-box-info col-md-6" }, [
                        _c("div", { staticClass: "container" }, [
                          _c("div", { staticClass: "row booking-indicator" }, [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _vm.claim.claim_status.name == "Closed"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "booking-indicator-wrap mt-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-8 px-0" },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  "Claim closed with resolution "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.claim.claim_resolution
                                                        .name
                                                    )
                                                  )
                                                ])
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-4 px-0 text-right reopen-btn",
                                              on: { click: _vm.reopenClaim }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-repeat reopen-ico"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "reopen-text" },
                                                [_vm._v("Reopen claim")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.refunds.length
                                    ? _c("ClaimRefunds", {
                                        attrs: {
                                          refunds: _vm.refunds,
                                          claim: _vm.claim
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("ClaimAssigneInfo", {
                                    attrs: { "claim-by-id": _vm.claim },
                                    on: { update: _vm.getClaim }
                                  }),
                                  _vm._v(" "),
                                  _c("ClaimDescription", {
                                    attrs: { "claim-by-id": _vm.claim },
                                    on: { update: _vm.getClaim }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mail-info col-md-12 flex mt-4",
                                      class: [
                                        _vm.claim.acknowledgement_sent == 0
                                          ? "mail-orange"
                                          : "mail-green"
                                      ]
                                    },
                                    [
                                      _c("div", { staticClass: "col-md-8" }, [
                                        _vm.claim.acknowledgement_sent == 0
                                          ? _c(
                                              "span",
                                              {
                                                on: { click: _vm.toggleModal }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-exclamation-triangle mail-warning-icon"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "acknowledge-msg"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Acknowledgement email has not been sent yet."
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.claim.acknowledgement_sent == 1
                                          ? _c("span", [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-envelope mail-envelope-icon"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "acknowledge-msg"
                                                },
                                                [
                                                  _vm._v(
                                                    "Acknowledgement email has been sent."
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _vm.claim.acknowledgement_sent == 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-4 flex flex-justify-end"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  on: {
                                                    click: _vm.toggleSidebar
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-paper-plane mail-plane-icon"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "button-send-email"
                                                    },
                                                    [_vm._v("Send email")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ClaimSettlementAmount", {
                                    attrs: { claim: _vm.claim },
                                    on: { update: _vm.getClaim }
                                  }),
                                  _vm._v(" "),
                                  _c("ClaimAttachments", {
                                    attrs: { claim: _vm.claim },
                                    on: { update: _vm.getClaim }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "comments col-md-6" },
                        [
                          _c("Comments", {
                            attrs: { claim: _vm.claim },
                            on: { update: _vm.getClaim }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.showCustomerModal
                  ? _c(
                      "div",
                      {
                        staticClass: "l-modal-mask",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            _vm.showCustomerModal = false
                          }
                        }
                      },
                      [
                        _vm.showCustomerModal
                          ? _c("SideModalCustomerInfo", {
                              attrs: {
                                "claim-id": _vm.claim.id,
                                data: _vm.claim.job
                              },
                              on: {
                                "show-customer-modal-toggle": function($event) {
                                  _vm.showCustomerModal = !_vm.showCustomerModal
                                },
                                update: function($event) {
                                  _vm.getClaim()
                                  _vm.getJob()
                                },
                                cancel: function($event) {
                                  _vm.showCustomerModal = false
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.showEmailModal
                  ? _c(
                      "div",
                      { staticClass: "l-modal-mask" },
                      [
                        _c("send-claim-email", {
                          staticClass: "sidebar-right",
                          attrs: { job: _vm.claim.job, "type-id": 2 },
                          on: {
                            cancel: function($event) {
                              _vm.toggleSidebar()
                            },
                            update: _vm.getClaim
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.ackModal
                ? _c(
                    "modal",
                    {
                      attrs: { size: "modal-small", "close-strict": true },
                      on: {
                        close: function($event) {
                          _vm.ackModal = false
                        }
                      }
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-10" })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                        _c("div", { staticClass: "row text-center mt-3 p-4" }, [
                          _c("h4", [
                            _vm._v(
                              "This action will mark that the acknowledgement email was sent to the customer. Please confirm to proceed."
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                        _c("div", { staticClass: "row mb-2 mt-4" }, [
                          _c("div", { staticClass: "col text-center" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.ackModal = false
                                  }
                                }
                              },
                              [_vm._v("\n              Cancel\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary ld-ext-right",
                                class: _vm.loadingButton ? "running" : "",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.buttonDisabled
                                },
                                on: { click: _vm.overrideAcknowledgement }
                              },
                              [
                                _vm._v(
                                  "\n              Yes, confirm\n              "
                                ),
                                _c("div", { staticClass: "ld ld-ball ld-flip" })
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _c(
            "vue-content-loading",
            { attrs: { width: 800, height: 450 } },
            _vm._l(15, function(x) {
              return _c("rect", {
                key: x,
                attrs: {
                  x: "10",
                  y: 15 * x * 1.4,
                  rx: "5",
                  ry: "5",
                  width: "720",
                  height: "6"
                }
              })
            })
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13d0df79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13d0df79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimsEdit.vue
// module id = null
// module chunks = 